export class CheckoutPaymentHandler {
  constructor(STRIPE_PUBLISHABLE_KEY) {
    this.STRIPE_PUBLISHABLE_KEY = STRIPE_PUBLISHABLE_KEY
  }

  attach() {
    /*
      We send all credit card details directly to Stripe utilizing Stripe Elements
      https://stripe.com/elements
    */
    let stripe = Stripe(this.STRIPE_PUBLISHABLE_KEY)
    let elements = stripe.elements()

    // Custom styling recommended by Stripe
    let style = {
      base: {
        color: '#32325d',
        lineHeight: '18px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    }

    let card = elements.create('card', { style: style })
    card.mount('#card-element')

    card.addEventListener('change', event => {
      let displayError = document.getElementById('card-errors')
      if (event.error) {
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ''
      }
    })

    // Create a token or display an error when the form is submitted.
    let form = document.getElementById('payment-form')
    form.addEventListener('submit', event => {
      event.preventDefault()

      stripe.createToken(card).then(result => {
        if (result.error) {
          // Inform the customer that there was an error.
          let errorElement = document.getElementById('card-errors')
          errorElement.textContent = result.error.message
        } else {
          // Send the token to the server.
          this.stripeTokenHandler(result.token)
        }
      })
    })
  }

  /*
    Stripe Token Handler function that assigns the generated stripe token to a
    hidden form input to be sent to the server.
  */
  stripeTokenHandler = token => {
    // Insert the token ID into the form so it gets submitted to the server
    let form = document.getElementById('payment-form')
    let hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', 'stripe_token')
    hiddenInput.setAttribute('value', token.id)
    form.appendChild(hiddenInput)

    form.submit()
  }
}
